<template>
    <div class="signDialog" v-loading="loading">
        <sign-in-form ref="signInForm"></sign-in-form>
        <sign-in-table ref="signInTable"></sign-in-table>
    </div>
</template>
<script>
import SignInForm from './SignInForm.vue';
import SignInTable from './SignInTable.vue';
import { getLastmileReceiptDetail } from '@/modules/transport/otp/api/performanceReceiptSign.js';
import { dictWithUrl } from '@/components/lots/api.js';
export default {
    name: 'netSignInDetail',
    components: {
        SignInForm,
        SignInTable
    },
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            loading: false,
            signInInfo: {}
        };
    },
    mounted () {
        this.getNetReceiptDetail();
    },
    methods: {
        async getNetReceiptDetail () {
            this.loading = true;
            const dict = await dictWithUrl('ADDED_SERVICE');
            const dictData = dict.data;
            getLastmileReceiptDetail({ orderNo: this.rowData.orderNo }).then(res => {
                if (res && +res.code === 0) {
                    this.signInInfo = res.data || {};
                    this.signInInfo.addedServiceTypeName = dictData.ADDED_SERVICE[this.signInInfo.addedServiceType] || '';
                    this.$refs.signInForm.initFormData(this.signInInfo);
                    this.$refs.signInTable.initTableData(this.signInInfo.receiptLastmileDetailQueryResponseDtos || []);
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>
